import Url from 'domurl';

const wrapQuery = query => `<b>${query}</b>`;
const escape = query => query.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export default {
  computed: {
    getCategories() {
      return this.list.filter(item => item.meta.bread_crumb);
    },
    getSimpleSuggesting() {
      return this.list.filter(item => !item.meta.bread_crumb && !item.meta.id);
    },
    getProductsList() {
      return this.list.filter(item => item.meta.id);
    },
  },
  methods: {
    clickLinkHandler(value) {
      this.$emit('setCurrentLinkTitle', value);
    },
    getSearchCaption(caption, query) {
      if (query) {
        const re = new RegExp(escape(query), 'ig');
        return caption.replace(re, wrapQuery);
      }

      return caption;
    },
    getUrl(key = 'query', value = '', path = '') {
      const url = new Url();
      if (typeof value === 'string' && value.length) {
        const query = url.query;
        query[key] = value;
      }
      if (typeof path === 'string' && !!path.length) {
        url.path = path;
      }
      return url.toString();
    },
  },
};
